import { data } from '../../svg/Warning/data';
import { makeIcon } from '../makeIcon';

export const Warning = makeIcon(data, 'warning', 'Warning');

export default Warning;
